import React, { } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, Field, Model, POST, errorCatch, updateInArray, useAuth } from 'fennec-ui';
import { useOrganizerContext, useTeacherContext } from '../../../../common/Context';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Settings(props) {
    let { id } = useParams();
    const auth = useAuth();

    // const sourceKey = "promouter";
    // const [event, setEvent] = useState(undefined);
    // useEffect(() => {
    //     GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
    //         ({ data }) => {
    //             if (data && data.length) {
    //                 setEvent(data[0]);
    //             }
    //         }, errorCatch);
    // }, [])

    const [org, setOrg] = useOrganizerContext()
    const osnovi = _.get(org, "osnoviPromokodovOrganizatorFederatsii[0]")
    
    return (
        <PageLayout hideSider={false}>
            <div style={{ backgroundColor: "white", padding: "4px 15px", borderRadius: "4px" }}>
                <div>
                    <div>
                        <div style={{ fontSize: "16px" }}>Параметры промокодов</div>
                        {/* <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                            Параметры промокодов
                        </div> */}
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <Action
                            auth={auth}
                            okText="Сохранить"
                            action={(values, unlock, close) => {
                                // "/api/osnovipromokodov/new"
                                // "/api/osnovipromokodov/update"
                                // "/api/osnovipromokodov/delete"
                                if(values?.osnovaPromokoda && values?.osnovaPromokoda!==""){
                                    POST(auth, (!osnovi)?`/api/osnovipromokodov/new`:`/api/osnovipromokodov/update`, {
                                        ID: (osnovi)?osnovi.ID:undefined,
                                        prepodavatelShkoliID: undefined,
                                        shkolaFederatsiiID: undefined,
                                        prepodavatelFederatsiiID: undefined,
                                        organizatorFederatsiiID: org?.ID,
                                        osnovaPromokoda: values?.osnovaPromokoda,
                                    }, ({ data }) => {
                                        setOrg({...org, osnoviPromokodovOrganizatorFederatsii:updateInArray(org?.osnoviPromokodovOrganizatorFederatsii,data)})
                                        close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                } else if(osnovi){
                                    POST(auth, `/api/osnovipromokodov/delete`, {
                                        ID: (osnovi)?osnovi.ID:undefined,
                                        prepodavatelShkoliID: undefined,
                                        shkolaFederatsiiID: undefined,
                                        prepodavatelFederatsiiID: undefined,
                                        organizatorFederatsiiID: org?.ID,
                                        osnovaPromokoda: values?.osnovaPromokoda,
                                    }, ({ data }) => {
                                        setOrg({...org, osnoviPromokodovOrganizatorFederatsii: []})
                                        close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                }
                            }}

                            object={osnovi}
                            disabledOkOnUncahngedForm={true}

                            form={Model}
                            meta={[
                                {
                                    label: "Основа промокода",
                                    description: (<span><i className="fa fa-question-circle"></i> Применяется в качестве префикса при выдаче промокода организатором мероприятия</span>),
                                    name: "osnovaPromokoda",
                                    type: "string",
                                    size: "small"
                                }
                            ]}
                            mode={"inline"}
                        />
                    </div>
                </div>

                <div style={{marginTop:"20px"}}>
                    <div>
                        <div style={{ fontSize: "16px" }}> Параметры организатора</div>
                        {/* <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                            Параметры школы
                        </div> */}
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <Action
                            auth={auth}
                            okText="Сохранить"
                            action={(values, unlock, close) => {
                                POST(auth, `/api/org/update`, {
                                    ...org,
                                    ...values
                                }, ({ data }) => {
                                    setOrg(...org, ...data)
                                    close()
                                }, (err) => errorCatch(err, () => unlock()))
                            }}

                            object={org}
                            disabledOkOnUncahngedForm={true}

                            form={Model}
                            meta={[
                                {
                                    label: "Название",
                                    // description: (<span><i className="fa fa-question-circle"></i>  Создавать промокоды преподавателям школы</span>),
                                    name: "nazvanie",
                                    type: "string",
                                    size: "small"
                                },
                            ]}
                            mode={"inline"}
                        />
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
